module.exports = __webpack_public_path__ + "static/img/dtx.b9372cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dtx.png
// module id = 412
// module chunks = 2